(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-grid"] && !Shopify.designMode) return;
  try {
    
  if (window.innerWidth >= 768) {
    return
  }

  const container = document.querySelector('[js-media-grid="container"]')
  const dots = document.querySelectorAll('[js-media-grid="dot"]')

  container.addEventListener('scroll', () => {
    const items = Array.from(container.children)
    const containerWidth = container.offsetWidth
    const scrollLeft = container.scrollLeft
    const scrollWidth = container.scrollWidth

    const activeIndex = Math.floor(scrollLeft / (scrollWidth / items.length)) + 1

    dots.forEach(dot => dot.classList.remove('is-active'))
    dots[activeIndex].classList.add('is-active')
  })

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      dots.forEach(d => d.classList.remove('is-active'))

      const index = dot.getAttribute('data-index')
      const element = document.querySelector(`[js-media-grid="item"][data-index="${index}"]`)

      dot.classList.add('is-active')

      element.parentNode.scrollTo({
        left: element.offsetLeft - element.parentNode.offsetLeft,
        behavior: 'smooth'
      })
    })
  })

  } catch(e) { console.error(e); }
})();
})();
